// extracted by mini-css-extract-plugin
module.exports = {"dialog":"sandbox-auth-renewal-dialog_dialog__x48do"};